import * as urlWebservice from "utils/apis"
import * as actionsWebservice from "utils/functions/httpMethods"
import { defaultOptionsMultipart } from "utils/functions/httpMethods"

// Create a new package
export const createPackage = async (payload) => {
  try {
    const results = await actionsWebservice.post(urlWebservice.CREATE_PACKAGE, payload)
    // console.log("results ====>",results);

    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Update a package
export const updatePackage = async (packageId, payload) => {
  try {
    const results = await actionsWebservice.updateSafe(`${urlWebservice.ROOT_PACKAGE}/${packageId}`, payload)
    return results
  } catch (error) {
    throw error
  }
}

// Delete a package
export const deletePackage = async (packageId) => {
  try {
    const results = await actionsWebservice.removeSafe(`${urlWebservice.ROOT_PACKAGE}/${packageId}`)
    return results
  } catch (error) {
    throw error
  }
}

// Find all packages
export const findAllPackages = async (
  companyName = "",
  status = "",
  startDate = "",
  endDate = "",
  pageNumber,
  searchWord,
  isPrinted,
  account,
  isConfirmed
) => {
  try {
    const results = await actionsWebservice.get(
      `${urlWebservice.FIND_ALL_PACKAGES}?companyName=${companyName}&packageStatus=${status}&startDate=${startDate}&endDate=${endDate}&rowsOfPage=10&pageNumber=${pageNumber}&searchWord=${searchWord}&isPrinted=${isPrinted}&account=${account}&isConfirmed=${isConfirmed}`
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Find package by id
export const findOnePackage = async (packageId) => {
  try {
    const results = await actionsWebservice.get(`${urlWebservice.ROOT_PACKAGE}/${packageId}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Get revenues per company
export const getRevenues = async () => {
  try {
    const results = await actionsWebservice.get(urlWebservice.CALCULATE_REVENUES)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Calculate total revenue
export const calculateTotalRevenue = async (payload) => {
  try {
    const results = await actionsWebservice.post(urlWebservice.CALCULATE_PACKAGES_REVENUE, payload)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Find all missing packages
export const findAllTrackingPackages = async (rowsOfPage, pageNumber) => {
  try {
    const results = await actionsWebservice.get(
      `${urlWebservice.FIND_ALL_TRACKING_PACKAGES}?rowsOfPage=${rowsOfPage}&pageNumber=${pageNumber}`
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Tracking returned packages
export const trackingReturnedPackages = async (rowsOfPage, pageNumber) => {
  try {
    const results = await actionsWebservice.get(
      `${urlWebservice.TRACKING_RETURNED_PACKAGES}?rowsOfPage=${rowsOfPage}&pageNumber=${pageNumber}`
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Tracking missing packages
export const trackingMissingPackages = async (rowsOfPage, pageNumber) => {
  try {
    const results = await actionsWebservice.get(
      `${urlWebservice.TRACKING_MISSING_PACKAGES}?rowsOfPage=${rowsOfPage}&pageNumber=${pageNumber}`
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Get list of governorates
export const findAllGovernorates = async () => {
  try {
    const results = await actionsWebservice.get(urlWebservice.FIND_ALL_GOVERNORATES)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Print Lazajella PDF package
export const printLazajellaPDF = async (barcode) => {
  try {
    const results = await actionsWebservice.get(`${urlWebservice.PRINT_LAZAJELLA_PDF}/${barcode}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Generate package QRcode and barcode
export const generateCodes = async (barcode) => {
  try {
    const results = await actionsWebservice.post(`${urlWebservice.GENERATE_QRCODE}/${barcode}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Refresh all status
export const refreshStatus = async () => {
  try {
    const results = await actionsWebservice.get(urlWebservice.REFRESH_STATUS)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Refresh missing packages
export const refreshMissingPackages = async () => {
  try {
    const results = await actionsWebservice.get(urlWebservice.REFRESH_MISSING_PACKAGES)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Update returned package
export const updateReturnedPackage = async (packageId, payload) => {
  try {
    const results = await actionsWebservice.update(`${urlWebservice.UDPDATE_RETURNED_PACKAGE}/${packageId}`, payload)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Cancel a package
export const cancelPackage = async (packageId) => {
  try {
    const results = await actionsWebservice.post(`${urlWebservice.CANCEL_PACKAGE}/${packageId}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

export const payedPackages = async (payload) => {
  try {
    const results = await actionsWebservice.putMethod(
      `${urlWebservice.PAYED_PACKAGES}`,
      payload,
      defaultOptionsMultipart()
    )
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Update returned package
export const updatePackageStatus = async (barcode, payload) => {
  try {
    const results = await actionsWebservice.putMethod(`${urlWebservice.UDPDATE_PACKAGE_STATUS}/${barcode}`, payload)
    return results
  } catch (error) {
    return error
  }
}

// new services

// Confirm a single package
export const confirmPackage = async (packageId) => {
  try {
    const results = await actionsWebservice.postSafe(urlWebservice.CONFIRM_PACKAGE(packageId), {})
    return results
  } catch (error) {
    throw error
  }
}

// Confirm multiple packages
export const confirmMultiplePackages = async (packageIds = []) => {
  try {
    const results = await actionsWebservice.post(urlWebservice.CONFIRM_MULTIPLE_PACKAGES, { packageIds })
    return results
  } catch (error) {
    return error
  }
}

// Cancel an unconfirmed package
export const cancelUnconfirmedPackage = async (packageId) => {
  try {
    const results = await actionsWebservice.post(urlWebservice.CANCEL_UNCONFIRMED_PACKAGE(packageId))
    return results
  } catch (error) {
    return error
  }
}

// delete unconfirmed package
// export const deleteUnconfirmedPackage = async (packageId) => {
//   try {
//     const results = await actionsWebservice.remove(urlWebservice.DELETE_UNCONFIRMED_PACKAGE(packageId))
//     return results
//   } catch (error) {
//     return error
//   }
// }

// Récupérer tous les colis à retourner
export const findAllPackagesToReturned = async (searchWord = "") => {
  try {
    const query = new URLSearchParams({ searchWord }).toString()
    const results = await actionsWebservice.get(`${urlWebservice.FIND_ALL_PACKAGES_TO_RETURNED}?${query}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Marquer des colis comme retournés
export const markPackagesAsReturned = async (barcodes) => {
  try {
    return await actionsWebservice.post(urlWebservice.MARKE_PACKAGES_AS_RETURNED, { barcodes })
  } catch (error) {
    throw new Error(error)
  }
}
